import React, { useEffect } from "react";
import { useLocalStorage } from "../../lib/useLocalStorage";
import DcpContext from "../context/DcpContext";

const DcpFlowProvider = ({ children }) => {
  const [step1, setStep1] = useLocalStorage("DlpFlow.Step1", {
    isActive: true,
    isFinished: false,
  });
  const [step2, setStep2] = useLocalStorage(
    "DlpFlow.Step2",
    {
      isActive: false,
      isFinished: false,
    },
    true
  );
  const [step3, setStep3] = useLocalStorage("DlpFlow.Step3", {
    isActive: false,
    isFinished: false,
  });

  useEffect(() => {
    console.log("effect called for calculationStep");
  }, [step1]);
  useEffect(() => {
    console.log("effect called for personstep");
  }, [step2]);
  useEffect(() => {
    console.log("effect called for confirmationstep");
  }, [step3]);

  const context = {
    step1: {
      data: step1,
      setData: setStep1,
    },
    step2: {
      data: step2,
      setData: setStep2,
    },
    step3: {
      data: step3,
      setData: setStep3,
    },
  };

  return <DcpContext.Provider value={context}>{children}</DcpContext.Provider>;
};

export default DcpFlowProvider;
